module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }